import React, { useEffect, useState } from 'react';
import api from '../services/api';
import AdminMenu from '../components/AdminMenu';

const TMDB_API_KEY = '0c867cfbfa47cf1e70b33a5eac501d4a';
const TMDB_BASE_URL = 'https://api.themoviedb.org/3';

const placeholderImage = 'https://via.placeholder.com/500x750?text=Sin+Imagen';

function AdminNoticias() {
  const [itemsPerPage, setItemsPerPage] = useState(32);
  const [contenidos, setContenidos] = useState({
    ultimos: [],
    infantiles: [],
    masVistas: { peliculas: [], series: [] }
  });
  const [categoria, setCategoria] = useState('ultimos');
  const [subCategoriaRecientes, setSubCategoriaRecientes] = useState('peliculas');
  const [modalData, setModalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [detallesCache, setDetallesCache] = useState({});
  const [paginaActual, setPaginaActual] = useState(1);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [servidorSeleccionado, setServidorSeleccionado] = useState('Mundiemby1');
  const [busqueda, setBusqueda] = useState('');
  const [notificacionModal, setNotificacionModal] = useState(false);
  const [nuevaNotificacion, setNuevaNotificacion] = useState({
    titulo: '',
    mensaje: '',
    tipo: 'todos',
    usuarioEspecifico: ''
  });

  // Configuración de servidores
  const nombresServidores = {
    Mundiemby1: "MundiEmby 1",
    Mundiemby2: "MundiEmby 2",
    Mundiemby3: "MundiEmby 3",
    Mundiemby4: "MundiEmby 4",
    Mundiemby5: "MundiEmby 5",
    Mundiemby6: "MundiEmby 6",
    Mundiemby7: "MundiEmby 7",
  };

  const servidoresEmby = {
    Mundiemby1: { url: "http://mundiemby.us.to:33421", api_key: "241ac4cd1eb74a6b9218ffc5fdb5efcf" },
    Mundiemby2: { url: "http://mundiemby.us.to:33428", api_key: "e825b3f79022462490d0591ab45e7acb" },
    Mundiemby3: { url: "http://mundiemby.us.to:33423", api_key: "1536b2acc91043e189e83008956e22fb" },
    Mundiemby4: { url: "http://mundiemby.us.to:33426", api_key: "b2cd008a7f4d4ab780d29165d5bcf1ef" },
    Mundiemby5: { url: "http://mundiemby.us.to:33422", api_key: "8a05cb8dc0f7402991448ecf6511cc3d" },
    Mundiemby6: { url: "http://mundiemby.us.to:33424", api_key: "47b40611aa7c42db8b03ff4848346711" },
    Mundiemby7: { url: "http://mundiemby.us.to:33427", api_key: "10f90d322cae460f8c357586b1cde83b" }
  };

  const serverIds = {
    Mundiemby1: "fba973edcf2a42d7be059836e5f346d2",
    Mundiemby2: "dd5f69e25426401da9d6e07c9313774e",
    Mundiemby3: "8abdc39571c449a78c4eaee44084795f",
    Mundiemby4: "2fe0c8512f1145bfbda3cbb33f8e7c90",
    Mundiemby5: "afc5e2e2dec24e4a9242254332457041",
    Mundiemby6: "c0cee1433e17457ab9ae0d3c1ce7c32a",
    Mundiemby7: "e7084912b2a44eeaab24015c39f0ad6e"
  };

  // Configuración responsive
  useEffect(() => {
    const calcularItemsPorPantalla = () => {
      const ancho = window.innerWidth;
      const alto = window.innerHeight;
      
      const columnas = ancho > 1400 ? 6 : ancho > 1100 ? 5 : ancho > 800 ? 4 : ancho > 600 ? 3 : 2;
      const filas = alto > 1000 ? 6 : alto > 800 ? 5 : alto > 600 ? 4 : 3;

      setItemsPerPage(columnas * filas);
    };

    calcularItemsPorPantalla();
    window.addEventListener('resize', calcularItemsPorPantalla);
    return () => window.removeEventListener('resize', calcularItemsPorPantalla);
  }, []);

  // Cargar contenidos según servidor seleccionado
  useEffect(() => {
    const cargarContenidos = async () => {
      setLoading(true);
      setError(null);
      try {
        let response;
        if (categoria === 'ultimos') {
          response = await api.get(`/noticias/emby/${servidorSeleccionado.toLowerCase()}`);
          setContenidos(prev => ({ ...prev, ultimos: response.data }));
          setPaginaActual(1);
        } else if (categoria === 'masVistas') {
          response = await api.get(`/noticias/emby/masvistos/${servidorSeleccionado.toLowerCase()}`);
          const peliculas = response.data.filter(c => c.tipo === 'pelicula');
          const series = response.data.filter(c => c.tipo === 'serie');
          setContenidos(prev => ({ ...prev, masVistas: { peliculas, series } }));
        } else if (categoria === 'infantiles') {
          response = await api.get(`/noticias/emby/infantiles/${servidorSeleccionado.toLowerCase()}`);
          setContenidos(prev => ({ ...prev, infantiles: response.data }));
        }
      } catch (err) {
        console.error(err);
        setError('No se pudieron cargar los contenidos. Intente más tarde.');
      } finally {
        setLoading(false);
      }
    };
    
    cargarContenidos();
  }, [categoria, servidorSeleccionado]);

  // Precarga detalles TMDB
  useEffect(() => {
    if (contenidos.ultimos.length === 0) return;
    contenidos.ultimos.forEach(async (item) => {
      const tipo = item.tipo === 'serie' || item.tipo === 'series' ? 'serie' : 'pelicula';
      await fetchDetallesTMDB(item.tmdb_id, tipo);
    });
  }, [contenidos.ultimos]);

  const fetchDetallesTMDB = async (tmdbId, tipo) => {
    if (!tmdbId) return null;
    if (detallesCache[tmdbId]) return detallesCache[tmdbId];
    try {
      const res = await fetch(`${TMDB_BASE_URL}/${tipo === 'serie' ? 'tv' : 'movie'}/${tmdbId}?api_key=${TMDB_API_KEY}&language=es-ES&append_to_response=credits`);
      if (!res.ok) throw new Error('Error al obtener detalles de TMDB');
      const data = await res.json();
      setDetallesCache(prev => ({ ...prev, [tmdbId]: data }));
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  // Construir URL Emby
  const construirUrlEmby = (embyId, servidor) => {
    if (!embyId || !servidor) return '#';
    const servidorCapitalizado = Object.keys(servidoresEmby).find(
      key => key.toLowerCase() === servidor.toLowerCase()
    ) || 'Mundiemby1';
  
    const baseUrl = servidoresEmby[servidorCapitalizado]?.url;
    const serverIdReal = serverIds[servidorCapitalizado] || '';
    return `${baseUrl}/web/index.html#!/item?id=${embyId}&serverId=${serverIdReal}`;
  };

  // Filtrado y paginación
  const ultimosFiltrados = contenidos.ultimos.filter(item => {
    const tipo = (item.tipo || '').toLowerCase().trim();
    const coincideTipo = subCategoriaRecientes === 'peliculas'
      ? ['pelicula', 'movie'].includes(tipo)
      : ['serie', 'series', 'tv', 'episode'].includes(tipo);
    
    const coincideBusqueda = busqueda === '' || 
      (item.titulo && item.titulo.toLowerCase().includes(busqueda.toLowerCase())) ||
      (detallesCache[item.tmdb_id]?.title && detallesCache[item.tmdb_id].title.toLowerCase().includes(busqueda.toLowerCase())) ||
      (detallesCache[item.tmdb_id]?.name && detallesCache[item.tmdb_id].name.toLowerCase().includes(busqueda.toLowerCase()));

    return coincideTipo && coincideBusqueda;
  });
  
  const totalItems = ultimosFiltrados.length;
  const totalPaginas = Math.ceil(totalItems / itemsPerPage);
  const contenidosPaginaActual = ultimosFiltrados.slice(
    (paginaActual - 1) * itemsPerPage,
    paginaActual * itemsPerPage
  );

  // Funciones de paginación
  const handlePaginaAnterior = () => paginaActual > 1 && setPaginaActual(paginaActual - 1);
  const handlePaginaSiguiente = () => paginaActual < totalPaginas && setPaginaActual(paginaActual + 1);

  // Funciones para el modal de detalles
  const abrirDetalles = async (item) => {
    const tipoApi = item.tipo === 'serie' || item.tipo === 'series' ? 'serie' : 'pelicula';
    const detallesTMDB = await fetchDetallesTMDB(item.tmdb_id, tipoApi);
    setModalData({ ...item, detallesTMDB, tipo: tipoApi === 'pelicula' ? 'Película' : 'Serie' });
  };

  const cerrarModal = () => setModalData(null);

  // Funciones para notificaciones
  const enviarNotificacion = async () => {
    try {
      await api.post('/notificaciones', {
        titulo: nuevaNotificacion.titulo,
        mensaje: nuevaNotificacion.mensaje,
        destinatario: nuevaNotificacion.tipo === 'todos' ? null : nuevaNotificacion.usuarioEspecifico
      });
      alert('Notificación enviada correctamente');
      setNotificacionModal(false);
      setNuevaNotificacion({
        titulo: '',
        mensaje: '',
        tipo: 'todos',
        usuarioEspecifico: ''
      });
    } catch (error) {
      console.error('Error al enviar notificación:', error);
      alert('Error al enviar notificación');
    }
  };

  // Renderizado de tarjetas
  const renderCard = (item) => {
    const posterUrl =
      item.caratula ||
      (detallesCache[item.tmdb_id]?.poster_path
        ? `https://image.tmdb.org/t/p/w600_and_h900_bestv2${detallesCache[item.tmdb_id].poster_path}`
        : null) ||
      placeholderImage;

    return (
      <div 
        key={item.id} 
        className="card" 
        onClick={() => abrirDetalles(item)}
        onMouseEnter={() => setHoveredCard(item.id)}
        onMouseLeave={() => setHoveredCard(null)}
      >
        <div className="card-image">
          <img
            src={posterUrl}
            alt={item.titulo || 'Sin título'}
            onError={e => {
              e.target.onerror = null;
              e.target.src = placeholderImage;
            }}
          />
        </div>
        <div className="card-info">
          <h3 className="card-title">
            {detallesCache[item.tmdb_id]?.title || detallesCache[item.tmdb_id]?.name || item.titulo || 'Sin título'}
          </h3>
          {detallesCache[item.tmdb_id]?.release_date || detallesCache[item.tmdb_id]?.first_air_date ? (
            <div className="anio">
              {new Date(detallesCache[item.tmdb_id].release_date || detallesCache[item.tmdb_id].first_air_date).getFullYear()}
            </div>
          ) : null}
          {item.temporada != null && <div className="temporada">Temporada {item.temporada}</div>}
          {item.episodio != null && <div className="episodio">Episodio {item.episodio}</div>}
        </div>
        {hoveredCard === item.id && (item.descripcion || item.descripcion_episodio) && (
          <div className="card-synopsis">
            <p>{item.descripcion_episodio || item.descripcion}</p>
          </div>
        )}
      </div>
    );
  };

  const renderListado = (items) => (
    <div className="grid">
      {items.length > 0 ? items.map(renderCard) : <div className="empty-message">No hay contenidos disponibles</div>}
    </div>
  );

  if (loading) return <div className="loading">Cargando contenidos...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="admin-noticias-container">
      <AdminMenu />
      
      <h2>Administrador de Contenidos y Notificaciones</h2>

      {/* Selector de servidor */}
      <div className="servidor-selector">
        <label>Servidor:</label>
        <select 
          value={servidorSeleccionado}
          onChange={(e) => setServidorSeleccionado(e.target.value)}
        >
          {Object.keys(nombresServidores).map(servidor => (
            <option key={servidor} value={servidor}>
              {nombresServidores[servidor]}
            </option>
          ))}
        </select>
      </div>

      {/* Barra de búsqueda */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Buscar contenido..."
          value={busqueda}
          onChange={(e) => {
            setBusqueda(e.target.value);
            setPaginaActual(1);
          }}
        />
      </div>

      {/* Botón para enviar notificaciones */}
      <div className="notificaciones-control">
        <button 
          className="btn-notificacion"
          onClick={() => setNotificacionModal(true)}
        >
          📢 Enviar Notificación
        </button>
      </div>

      {/* Tabs de categorías */}
      <div className="tabs">
        <button className={categoria === 'ultimos' ? 'active' : ''} onClick={() => setCategoria('ultimos')}>
          Recientes
        </button>
        <button className={categoria === 'masVistas' ? 'active' : ''} onClick={() => setCategoria('masVistas')}>
          Más Vistos
        </button>
        <button className={categoria === 'infantiles' ? 'active' : ''} onClick={() => setCategoria('infantiles')}>
          Infantiles
        </button>
      </div>

      {/* Contenido principal */}
      {categoria === 'ultimos' && (
        <>
          <h3>Últimos añadidos en {nombresServidores[servidorSeleccionado]}</h3>
          <div className="subtabs">
            <button className={subCategoriaRecientes === 'peliculas' ? 'active' : ''} onClick={() => setSubCategoriaRecientes('peliculas')}>
              Películas
            </button>
            <button className={subCategoriaRecientes === 'series' ? 'active' : ''} onClick={() => setSubCategoriaRecientes('series')}>
              Series
            </button>
          </div>

          {renderListado(contenidosPaginaActual)}

          {totalPaginas > 1 && (
            <div className="pagination">
              <button onClick={handlePaginaAnterior} disabled={paginaActual === 1}>
                ← Anterior
              </button>
              <span>
                Página {paginaActual} de {totalPaginas}
              </span>
              <button onClick={handlePaginaSiguiente} disabled={paginaActual === totalPaginas}>
                Siguiente →
              </button>
            </div>
          )}
        </>
      )}

      {categoria === 'masVistas' && (
        <>
          <h3>Películas más vistas en {nombresServidores[servidorSeleccionado]}</h3>
          {renderListado(contenidos.masVistas.peliculas)}
          <h3>Series más vistas en {nombresServidores[servidorSeleccionado]}</h3>
          {renderListado(contenidos.masVistas.series)}
        </>
      )}

      {categoria === 'infantiles' && (
        <>
          <h3>Contenido infantil en {nombresServidores[servidorSeleccionado]}</h3>
          {renderListado(contenidos.infantiles)}
        </>
      )}

      {/* Modal de detalles */}
      {modalData && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={cerrarModal}>×</button>

            <div className="modal-header">
              <img
                src={
                  modalData.detallesTMDB?.poster_path
                    ? `https://image.tmdb.org/t/p/w500${modalData.detallesTMDB.poster_path}`
                    : modalData.caratula || placeholderImage
                }
                alt={modalData.titulo}
              />
              <div className="modal-title">
                <h2>{modalData.titulo}</h2>
                {modalData.temporada != null && modalData.episodio != null && (
                  <div className="episode-title">
                    <span>Temporada {modalData.temporada}</span>
                    <span>Episodio {modalData.episodio}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="modal-body">
              {modalData.descripcion_episodio && (
                <>
                  <h4>Sinopsis del episodio:</h4>
                  <p>{modalData.descripcion_episodio}</p>
                </>
              )}
              <h4>Sinopsis {modalData.tipo === 'Película' ? 'de la película' : 'de la serie'}:</h4>
              <p>{modalData.detallesTMDB?.overview || modalData.descripcion || 'Descripción no disponible'}</p>

              <div className="details-grid">
                <div>
                  <h4>Género</h4>
                  <p>{modalData.detallesTMDB?.genres?.map(g => g.name).join(', ') || modalData.genero || 'Desconocido'}</p>
                </div>
                <div>
                  <h4>Reparto</h4>
                  <p>{modalData.detallesTMDB?.credits?.cast?.slice(0, 5).map(a => a.name).join(', ') || 'No disponible'}</p>
                </div>
                <div>
                  <h4>Servidor</h4>
                  <p>{modalData.servidor}</p>
                </div>
              </div>

              <div className="modal-actions">
                <a
                  href={construirUrlEmby(modalData.emby_id, modalData.servidor)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-ver-emby"
                >
                  ▶ Ver en Emby
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de notificaciones */}
      {notificacionModal && (
        <div className="modal-overlay" onClick={() => setNotificacionModal(false)}>
          <div className="modal-content notificacion-modal" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={() => setNotificacionModal(false)}>×</button>
            <h3>Enviar Notificación</h3>
            
            <div className="form-group">
              <label>Título:</label>
              <input
                type="text"
                value={nuevaNotificacion.titulo}
                onChange={(e) => setNuevaNotificacion({...nuevaNotificacion, titulo: e.target.value})}
                placeholder="Título de la notificación"
              />
            </div>
            
            <div className="form-group">
              <label>Mensaje:</label>
              <textarea
                value={nuevaNotificacion.mensaje}
                onChange={(e) => setNuevaNotificacion({...nuevaNotificacion, mensaje: e.target.value})}
                placeholder="Mensaje de la notificación"
                rows="4"
              />
            </div>
            
            <div className="form-group">
              <label>Tipo de envío:</label>
              <select
                value={nuevaNotificacion.tipo}
                onChange={(e) => setNuevaNotificacion({...nuevaNotificacion, tipo: e.target.value})}
              >
                <option value="todos">Todos los usuarios</option>
                <option value="especifico">Usuario específico</option>
              </select>
            </div>
            
            {nuevaNotificacion.tipo === 'especifico' && (
              <div className="form-group">
                <label>Nombre de usuario:</label>
                <input
                  type="text"
                  value={nuevaNotificacion.usuarioEspecifico}
                  onChange={(e) => setNuevaNotificacion({...nuevaNotificacion, usuarioEspecifico: e.target.value})}
                  placeholder="Nombre de usuario"
                />
              </div>
            )}
            
            <div className="modal-actions">
              <button 
                className="btn-cancelar"
                onClick={() => setNotificacionModal(false)}
              >
                Cancelar
              </button>
              <button 
                className="btn-enviar"
                onClick={enviarNotificacion}
                disabled={!nuevaNotificacion.titulo || !nuevaNotificacion.mensaje || 
                  (nuevaNotificacion.tipo === 'especifico' && !nuevaNotificacion.usuarioEspecifico)}
              >
                Enviar Notificación
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .admin-noticias-container {
          padding: 20px;
          color: white;
          max-width: 1400px;
          margin: 0 auto;
        }
        
        /* Selector de servidor */
        .servidor-selector {
          margin: 20px 0;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        
        .servidor-selector label {
          font-weight: bold;
        }
        
        .servidor-selector select {
          padding: 8px 12px;
          background: #333;
          color: white;
          border: 1px solid #555;
          border-radius: 4px;
          min-width: 150px;
        }
        
        /* Barra de búsqueda */
        .search-bar {
          margin: 20px 0;
        }
        
        .search-bar input {
          width: 100%;
          max-width: 500px;
          padding: 10px 15px;
          background: #333;
          color: white;
          border: 1px solid #555;
          border-radius: 4px;
          font-size: 1rem;
        }
        
        /* Control de notificaciones */
        .notificaciones-control {
          margin: 20px 0;
        }
        
        .btn-notificacion {
          padding: 10px 20px;
          background: #ff9800;
          color: black;
          border: none;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s;
        }
        
        .btn-notificacion:hover {
          background: #f57c00;
        }
        
        /* Tabs */
        .tabs {
          display: flex;
          gap: 10px;
          margin: 20px 0;
        }
        
        .tabs button {
          padding: 10px 20px;
          background: #333;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s;
        }
        
        .tabs button.active {
          background: #00c853;
          color: black;
          font-weight: bold;
        }
        
        /* Subtabs */
        .subtabs {
          display: flex;
          gap: 10px;
          margin: 10px 0 20px;
        }
        
        .subtabs button {
          padding: 8px 18px;
          background: #444;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s;
        }
        
        .subtabs button.active {
          background: #0091ea;
          color: white;
          font-weight: bold;
        }
        
        /* Grid de contenidos */
        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
          gap: 20px;
          margin-top: 15px;
        }
        
        /* Tarjetas */
        .card {
          width: 140px;
          background: #1e1e1e;
          border-radius: 8px;
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.3s;
          position: relative;
          z-index: 0;
        }
        
        .card:hover {
          transform: scale(1.5);
          z-index: 10;
          box-shadow: 0 10px 20px rgba(0,0,0,0.8);
        }
        
        .card-image {
          position: relative;
          padding-top: 150%;
          overflow: hidden;
        }
        
        .card-image img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .card-info {
          padding: 12px;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        
        .card-title {
          margin: 0;
          font-size: 0.85rem;
          line-height: 1.2;
          word-break: break-word;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          min-height: 2.8em;
        }
        
        .temporada, .episodio, .anio {
          font-size: 0.75rem;
          color: #aaa;
          line-height: 1.2;
        }
        
        .card-synopsis {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: rgba(30, 30, 30, 0.95);
          padding: 12px;
          font-size: 0.8rem;
          line-height: 1.4;
          z-index: 20;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          max-height: 200px;
          overflow-y: auto;
        }
        
        .empty-message {
          grid-column: 1 / -1;
          text-align: center;
          padding: 40px;
          color: #777;
        }
        
        /* Paginación */
        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 20px;
          margin: 20px 0;
        }
        
        .pagination button {
          padding: 8px 16px;
          background: #333;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
        
        .pagination button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        /* Modales */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
        }
        
        .modal-content {
          background: #222;
          border-radius: 12px;
          max-width: 800px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
        }
        
        .notificacion-modal {
          max-width: 500px;
          padding: 20px;
        }
        
        .close-button {
          position: absolute;
          top: 15px;
          right: 15px;
          background: #ff4444;
          border: none;
          color: white;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          font-size: 1.2rem;
          cursor: pointer;
          z-index: 10;
        }
        
        /* Estilos específicos para el modal de detalles */
        .modal-header {
          position: relative;
          display: flex;
          align-items: flex-end;
          min-height: 300px;
        }
        
        .modal-header img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 1;
        }
        
        .modal-header::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 100%;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent);
          z-index: 2;
        }
        
        .modal-title {
          position: relative;
          z-index: 3;
          padding: 20px;
          width: 100%;
        }
        
        .modal-title h2 {
          margin: 0;
          font-size: 1.8rem;
        }
        
        .modal-title .episode-title {
          display: flex;
          gap: 12px;
          margin: 8px 0;
          font-size: 1rem;
          color: #ddd;
          flex-wrap: wrap;
        }
        
        .modal-body {
          padding: 20px;
        }
        
        .modal-body h4 {
          color: #00c853;
          margin: 15px 0 5px 0;
          font-size: 1rem;
        }
        
        .modal-body p {
          line-height: 1.6;
          margin-bottom: 20px;
        }
        
        .details-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 20px;
          margin: 20px 0;
        }
        
        .modal-actions {
          text-align: center;
          margin-top: 20px;
        }
        
        .btn-ver-emby {
          display: inline-block;
          background: #00c853;
          color: black;
          padding: 10px 20px;
          border-radius: 6px;
          font-weight: bold;
          text-decoration: none;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        
        .btn-ver-emby:hover {
          background: #00b045;
          color: white;
        }
        
        /* Estilos para el formulario de notificaciones */
        .form-group {
          margin-bottom: 15px;
        }
        
        .form-group label {
          display: block;
          margin-bottom: 5px;
          font-weight: bold;
        }
        
        .form-group input,
        .form-group textarea,
        .form-group select {
          width: 100%;
          padding: 8px 12px;
          background: #333;
          color: white;
          border: 1px solid #555;
          border-radius: 4px;
          font-size: 1rem;
        }
        
        .form-group textarea {
          resize: vertical;
        }
        
        .btn-cancelar {
          padding: 10px 20px;
          background: #666;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          margin-right: 10px;
        }
        
        .btn-enviar {
          padding: 10px 20px;
          background: #4caf50;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
        }
        
        .btn-enviar:disabled {
          background: #666;
          cursor: not-allowed;
        }
        
        /* Responsive */
        @media (max-width: 768px) {
          .grid {
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
          }
          
          .modal-header {
            min-height: 200px;
          }
          
          .modal-title h2 {
            font-size: 1.4rem;
          }
          
          .card-title {
            font-size: 0.75rem;
            -webkit-line-clamp: 2;
          }
          
          .temporada, .episodio, .anio {
            font-size: 0.7rem;
          }
        }
      `}</style>
    </div>
  );
}

export default AdminNoticias;